import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { useLocation, useNavigate } from "react-router-dom";
import Toolbar from "../../componentes/toolbar/Toolbar";
import {
  descargarCroquisPorSolicitud,
  obtenerSolicitudDetalle,
  setCroquis,
  setMessageError,
  setSolicitudDetalle,
} from "../../sliceRedux/Reserva.slice";
import useFullPageLoader from "react-comun-seps/lib/components/FullPageLoaderHooks/useFullPageLoader";
import { useDispatch, useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import RevisarEntidad from "./RevisarEntidad";
import RevisarDenominacion from "./RevisarDenominacion";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";

const Revisar = () => {
  const toast = useRef(null);
  const stepperRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const { datos, codSolReservaDenominacion } = location.state || {};
  const messageError = useSelector((state) => state.reserva.messageError);
  const croquis = useSelector((state) => state.reserva.croquis);
  const solicitudDetalle = useSelector((state) => state.reserva.solicitudDetalle);

  useEffect(() => {
    showLoader();
    Promise.all([
      dispatch(obtenerSolicitudDetalle(codSolReservaDenominacion)),
      dispatch(descargarCroquisPorSolicitud(codSolReservaDenominacion)),
    ]).then(() => {
      hideLoader();
    });
  }, []);

  useEffect(() => {
    return () => {
      dispatch(setSolicitudDetalle({ ...solicitudDetalle, ...{ code: 0 } }));
    };
  }, [solicitudDetalle.code]);

  useEffect(() => {
    if (messageError != "") {
      RenderToast(toast, "error", "Error", messageError);
    }
    return () => {
      hideLoader();
      dispatch(setMessageError(""));
    };
  }, [messageError]);

  useEffect(() => {
    return () => {
      hideLoader();
      dispatch(setCroquis({ ...croquis, ...{ code: 0 } }));
    };
  }, [croquis.code]);

  return (
    <>
      {loader}
      <Toast ref={toast} />
      <div className="card">
        <Toolbar>
          <React.Fragment>
            <Button
              label="Regresar"
              icon="pi pi-arrow-circle-left"
              type="button"
              severity="info"
              onClick={(e) => {
                navigate("/solicitudes", { state: { datos: datos } });
              }}
            />
          </React.Fragment>
        </Toolbar>
        <div className="text-center">
          <div className="font-semibold text-lg text-blue-700">
            Solicitud de Reserva de Denominación: {solicitudDetalle?.object?.numSolicitud ?? ""}
          </div>
          <div className="font-semibold text-base m-2">
            Estado: {solicitudDetalle?.object?.nomEstadoSolicitud ?? ""}
          </div>
        </div>
        <Stepper className="stepperReserva" ref={stepperRef} style={{ flexBasis: "50rem" }}>
          <StepperPanel panelKey="panelEntidad" header="Entidad">
            <RevisarEntidad
              showLoader={showLoader}
              hideLoader={hideLoader}
              dispatch={dispatch}
              solicitud={solicitudDetalle?.object ?? {}}
              croquis={croquis?.object ?? {}}
            />
            <div className="text-center">
              <Button
                label="Siguiente"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="button"
                onClick={(e) => {
                  stepperRef.current.nextCallback();
                }}
              />
            </div>
          </StepperPanel>
          <StepperPanel panelKey="panelDenominacion" header="Denominación">
            <RevisarDenominacion
              datos={datos}
              navigate={navigate}
              solicitud={solicitudDetalle?.object ?? {}}
            />
            <div className="text-center">
              <Button
                label="Anterior"
                icon="pi pi-arrow-left"
                type="button"
                onClick={(e) => {
                  stepperRef.current.prevCallback();
                }}
              />
            </div>
          </StepperPanel>
        </Stepper>
      </div>
    </>
  );
};
export default Revisar;
